import { ArrayWrap } from ".";
import { AuthIdModel } from "@/models/client";
import { dateTimeMixins } from "@/mixins/date-time";

export type DxType = "string" | "number" | "date" | "boolean" | "object" | "datetime";

export interface FormattingMixins {
  formValue(value: any, dataType: DxType): string;
  formPrice(value?: number | bigint | string): string;
  formBoolean(value?: boolean | string): string;
  formPhone(value?: string): string;
  formPhoneNoPrefix(value?: string): string;
  trim(model: ArrayWrap<any>): ArrayWrap<any>;
  formAuthId(authModel: AuthIdModel): string | undefined;
  formAuthIdFromNumbers(storeNumber: number, clientNumber: number, cardholderNumber: number): string;
  getAuthId(authId: string): AuthIdModel;
  isEmptyString(value?: string | undefined | null): boolean;
  toLowerFirstChar(value: string | undefined): string;
}

export const formattingMixins: FormattingMixins = {
  formValue(value: any, dataType: DxType) {
    if (dataType == "boolean") {
      return this.formBoolean(value);
    } else if (!value) {
      return "";
    }
    switch (dataType) {
      case "date":
        return dateTimeMixins.formatDate(value, dateTimeMixins.dateFormat);
      case "datetime":
        return dateTimeMixins.formatDate(value, dateTimeMixins.dateTimeFormat);
      default:
        return String(value);
    }
  },
  formPrice(value?: number | bigint | string) {
    typeof value == "string" && (value = Number(value));
    return (value && new Intl.NumberFormat("ru-Ru").format(value)) || "";
  },
  formBoolean(value?: boolean | string): string {
    return value === "true" || (typeof value === "boolean" && value) ? "Да" : "Нет";
  },
  formPhone(value?: string | number): string {
    if (!value) {
      return "—";
    }
    typeof value !== "string" && (value = value.toString());
    const digits = value.match(/[\d*]+/g)?.join("") ?? "";
    if (digits.length === 11) {
      return digits.replace(/(.{1})(.{3})(.{3})(.{2})(.{2})/, "+$1 ($2) $3-$4-$5");
    } else {
      return "—";
    }
  },
  formPhoneNoPrefix(value?: string | number): string {
    if (value === undefined) {
      return "";
    }
    typeof value !== "string" && (value = value.toString());
    if (value.length === 10) {
      return value.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "($1) $2-$3-$4");
    } else {
      return "неверный формат";
    }
  },
  formAuthId(authModel: AuthIdModel): string | undefined {
    if (!authModel || !authModel.storeNumber || !authModel.clientNumber || !authModel.cardholderNumber) {
      return;
    }
    let auth_id =
      Number(authModel.storeNumber).toLocaleString("ru", {
        minimumIntegerDigits: 3,
        useGrouping: false,
      }) +
      Number(authModel.clientNumber).toLocaleString("ru", {
        minimumIntegerDigits: 8,
        useGrouping: false,
      });

    if (authModel.cardholderNumber) {
      auth_id += Number(authModel.cardholderNumber).toLocaleString("ru", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    }

    return auth_id.replace(/^0/, ""); //remove first character if it is 0
  },
  formAuthIdFromNumbers(storeNumber: number, clientNumber: number, cardholderNumber: number): string {
    const auth_id =
      storeNumber.toLocaleString("ru", {
        minimumIntegerDigits: 3,
        useGrouping: false,
      }) +
      clientNumber.toLocaleString("ru", {
        minimumIntegerDigits: 8,
        useGrouping: false,
      }) +
      cardholderNumber.toLocaleString("ru", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });

    return auth_id.replace(/^0/, ""); //remove first character if it is 0
  },
  getAuthId(authId: string): AuthIdModel {
    const authIdModel = new AuthIdModel();
    const matchResult = authId.match(/(^.{2,3})(..)(.{6})(..$)/);
    authIdModel.storeNumber = matchResult?.[1];
    authIdModel.clientNumber = matchResult?.[3];
    authIdModel.cardholderNumber = matchResult?.[4];
    return authIdModel;
  },
  trim(model: ArrayWrap<any>): ArrayWrap<any> {
    Object.entries(model).forEach(([key, value]) => {
      if (typeof value === "string") {
        model[key] = model[key].trim();
      }
    });
    return model;
  },
  isEmptyString(value?: string | undefined | null): boolean {
    return value === undefined || value === null || value === "";
  },
  toLowerFirstChar(value: string | undefined): string {
    return (value && value[0].toLowerCase() + value.slice(1)) || "";
  },
};

export default {
  methods: formattingMixins,
};
